/**
 * @generated SignedSource<<a9925f8170289b39fd8ceb960beabeee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type experimentMutationsEnrollMutation$variables = {
  experimentKey: string;
  vaultIds: ReadonlyArray<any>;
};
export type experimentMutationsEnrollMutation$data = {
  readonly enrollExperimentCohort: number;
};
export type experimentMutationsEnrollMutation = {
  response: experimentMutationsEnrollMutation$data;
  variables: experimentMutationsEnrollMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "experimentKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vaultIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "experimentKey",
        "variableName": "experimentKey"
      },
      {
        "kind": "Variable",
        "name": "vaultIds",
        "variableName": "vaultIds"
      }
    ],
    "kind": "ScalarField",
    "name": "enrollExperimentCohort",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "experimentMutationsEnrollMutation",
    "selections": (v1/*: any*/),
    "type": "FeatureToggleMutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "experimentMutationsEnrollMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ad04fcd14df8644922e72a641a7ac423",
    "id": null,
    "metadata": {},
    "name": "experimentMutationsEnrollMutation",
    "operationKind": "mutation",
    "text": "mutation experimentMutationsEnrollMutation(\n  $experimentKey: String!\n  $vaultIds: [UUID!]!\n) {\n  enrollExperimentCohort(experimentKey: $experimentKey, vaultIds: $vaultIds)\n}\n"
  }
};
})();

(node as any).hash = "0db905e5dda02b22e3f4e2e664baff96";

export default node;
